import React from 'react';

/**
 * 命理师预约支付包装器
 * 
 * 这是一个无操作的包装器，用于替代PayPalProvider，避免加载PayPal SDK。
 * 由于命理师预约现在使用服务器端PayPal集成，不再需要客户端SDK。
 */
const FortunePayPalWrapper = ({ children }) => {
  return <>{children}</>;
};

export default FortunePayPalWrapper;